import { Component, OnInit } from '@angular/core';

import { Country } from '../../shared/types/country/country';
import { Region } from '../../shared/types/organization/region';
import { CountryDirectoryRestService } from '../../shared/services/common/country-directory-rest.services';
import { RegionDirectoryRestService } from '../../shared/services/region/region-directory-rest.services';
@Component({
  selector: 'wsd-count-tab',
  templateUrl: './count-tab.component.html',
  styleUrls: ['./count-tab.component.css']
})
export class CountTabComponent implements OnInit {

  public block: boolean = false;
  public userTotalCount: number = 0;
  public allCountries: Country[];
  public allRegions: Region[];

  constructor(
    private countryDirectoryRestService: CountryDirectoryRestService,
    private regionDirectoryRestService: RegionDirectoryRestService
  ) { }

  ngOnInit() {
    this.initCountry();
    this.initRegion();
  }

  public search(): void {
  }

  protected initCountry(): void {
    this.block = true;
    this.countryDirectoryRestService.getAllCountries().subscribe(
      (countries: Country[]) => {
        this.block = false;
        this.allCountries = countries;
      },
      (error) => {
        this.block = false;
      }
    );
  }

  protected initRegion(): void {
    this.block = true;
    this.regionDirectoryRestService.getIdmRegions().subscribe(
      (regions: Region[]) => {
        this.block = false;
        this.allRegions = regions;
      },
      (error) => {
        this.block = false;
      }
    );
  }

  public triggerSpinner(value): void {
    this.block = value;
  }

}
